export default __webpack_public_path__ + "static/media/promo_09.9407ef3c.jpg";